<script setup lang="ts">
import { computed } from 'vue';

import { Locales } from '@/store/language.interface';
import { getTranslation } from '@/utils/data-display-utils';

// PROPS
const props = defineProps<{
  statistiques: any;
  labels: any;
  results?: any;
  languageEnabled?: Locales[];
  slider: any;
  showStats: boolean;
}>();

const stats = computed(() => (props.statistiques ? Object.values(props.statistiques) : []));
</script>
<template>
  <div class="wrapper">
    <div class="rate-results__title">
      {{ getTranslation(props.slider, 'name', props.languageEnabled) }}
    </div>
    <div class="rate-results" v-for="(value, index) in props.labels">
      <q-linear-progress
        :value="props.showStats ? stats[index] / 100 : undefined"
        :aria-label="`${getTranslation(value, 'label', props.languageEnabled)} ${stats[index]}%`"
      >
        <div class="rate-results__label">
          <div class="rate-results__label-response">
            <q-badge
              class="text-label"
              color="transparent"
              text-color="primary"
              :label="getTranslation(value, 'label', props.languageEnabled)"
            />
            <q-icon
              v-if="props.results && props.results.value_id[0] === value.value"
              color="primary"
              size="sm"
              name="check_circle"
            />
          </div>
          <q-badge
            v-if="props.showStats"
            class="value-label"
            color="transparent"
            text-color="primary"
            :label="`${stats[index]}%`"
          />
        </div>
      </q-linear-progress>
    </div>
  </div>
</template>
<style lang="scss">
.wrapper {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  background-color: $color-neutral-grey-300;
  padding: $space-md $space-md;
  border-radius: 8px;
  margin: $space-sm 0;

  .rate-results {
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;

    .q-linear-progress {
      display: flex;
      align-items: center;
      background-color: $color-neutral-grey-200 !important;
      color: $color-primary-50;
      border-radius: 8px !important;
      min-height: 36px;
      height: 100%;
    }

    &__title {
      font-weight: bold;
      font-size: $small-title;
      margin: 0 0 $space-xs 0;
    }

    &__label {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 100%;
      width: 100%;

      &-response {
        display: flex;
        flex-direction: row;
        align-items: center;
        max-width: 85%;
        overflow-wrap: break-word;

        .q-badge {
          font-size: $body-text !important;
          padding-left: 16px !important;
          position: relative;

          &--single-line {
            white-space: normal;
          }
        }
      }

      .q-badge {
        align-items: center;
        position: relative;
        top: auto;
        right: auto;
        border-radius: 4px !important;
        width: fit-content;
        font-size: $body-text !important;
        padding: $space-xs $space-xs $space-xs 0;
      }
    }
  }
}
</style>
